import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SttButton } from '../../sporttia/all';
import SttDisabledApiError from './SttDisabledApiError';

export default function SttDisabledApiPageError() {
    const { t } = useTranslation();

    return (
        <Box display="flex" justifyContent="center" alignItems="center">
            <Box pb={25} px={2}>
                <SttDisabledApiError />
                <Box display="flex" justifyContent="center" pt={2}>
                    <SttButton
                        caption={t('disabledApi.reload')}
                        onClick={() => {
                            window.location.assign(window.location.href);
                        }}
                    />
                </Box>
            </Box>
        </Box>
    );
}
